import { derived, writable } from 'svelte/store';

const API_KEY = import.meta.env.VITE_PEXELS_API_KEY;

/** @param {string} query */
const fetchPexelsBackgrounds = async (query) => {
  if (!query) return [];

  const params = new URLSearchParams({
    query,
    orientation: 'landscape',
    size: 'medium',
    per_page: '20'
  });
  const url = `https://api.pexels.com/v1/search?${params}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: API_KEY
      }
    });

    const data = await response.json();

    return data.photos.map((photo) => ({
      id: photo.id,
      thumbnail: photo.src.medium,
      full: photo.src.original,
      alt: photo.alt,
      photographer: photo.photographer,
      average: photo.avg_color
    }));
  } catch (error) {
    console.error('Error fetching images from Pexels:', error);
    return [];
  }
};

export const search = writable('');

/** @param {string} query */
export const setSearch = (query) => {
  search.set(query);
};

export const images = derived(
  search,
  ($search, set) => {
    fetchPexelsBackgrounds($search).then(set);
  },
  []
);
